var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28683 9.14272C3.28683 10.7494 3.96874 12.2903 5.15826 13.3713C6.2116 14.3294 7.59255 14.8561 9.0135 14.8561C9.19445 14.8561 9.37731 14.8475 9.55922 14.8303C12.4506 14.5542 14.7154 11.9665 14.7154 8.93796V8.19034H15.6678V6.28558H14.7154V5.80939C14.7154 2.92081 12.3659 0.571289 9.47731 0.571289H8.52493C5.63636 0.571289 3.28683 2.92081 3.28683 5.80939V6.28558H2.33445V8.19034H3.28683V9.14272ZM12.8106 8.93796C12.8106 10.9951 11.303 12.7503 9.37826 12.9342C8.28779 13.037 7.24303 12.6932 6.43922 11.9618C5.64588 11.2408 5.1916 10.2132 5.1916 9.14272V8.19034H12.8106V8.93796ZM5.1916 5.80939C5.1916 4.1332 6.43541 2.74177 8.04874 2.51034V5.3332H9.9535V2.51034C11.5668 2.74177 12.8106 4.1332 12.8106 5.80939V6.28558H5.1916V5.80939ZM17.5726 20.5713V23.4284H15.6678V20.5713C15.6678 18.9961 14.3859 17.7142 12.8106 17.7142H5.1916C3.61636 17.7142 2.33445 18.9961 2.33445 20.5713V23.4284H0.429688V20.5713C0.429688 17.9456 2.56588 15.8094 5.1916 15.8094H12.8106C15.4364 15.8094 17.5726 17.9456 17.5726 20.5713Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesIcon);
export default __webpack_public_path__ + "static/media/employees-icon.ea4e0ef061a29c093a24e5c78d38330d.svg";
export { ForwardRef as ReactComponent };